<template>
    <div class="ag-status-name-value status-bar" v-if="count_reservations">
        <span class="pr-1 text-block"><b>Total Reservations:</b> {{ count_reservations }}</span>
        <span class="pr-1 text-block"><b>Total Adults:</b> {{ adults }}</span>
        <span class="pr-1 text-block"><b>Total Children:</b> {{ children }}</span>
        <span class="pr-1 text-block"><b>Total Guests:</b> {{ guests }}</span>
    </div>
</template>

<script>
    import { getCurrentInstance } from 'vue';

    export default {
        name: 'totalStatusBar',
        data: function () {
            return {
                adults: null,
                children: null,
                guests: null,
                count_reservations: null,
            };
        },
        mounted() {
            this.params.api.addEventListener('modelUpdated', this.onModelUpdated.bind(this));
        },
        methods: {
            onModelUpdated() {
                const instance = getCurrentInstance();
                this.adults = instance?.parent?.parent?.data?.gridOptions?.context?.total?.adults;
                this.children =  instance?.parent?.parent?.data?.gridOptions?.context?.total?.children;
                this.guests =  instance?.parent?.parent?.data?.gridOptions?.context?.total?.guests;
                this.count_reservations =  instance?.parent?.parent?.data?.gridOptions?.context?.total?.count_reservations;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';
    .status-bar {
        text-align: right !important;
    }
    .left-number {
        left: 2em;
        position: absolute;
    }
    @include media-breakpoint-down(md) {
        .text-block {
            display: block;
        }
    }
</style>
